// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file notifications.proto (package river, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
/**
 * Describes the file notifications.proto.
 */
export const file_notifications = /*@__PURE__*/ fileDesc("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");
/**
 * Describes the message river.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 0);
/**
 * Describes the message river.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 1);
/**
 * Describes the message river.SetSettingsRequest.
 * Use `create(SetSettingsRequestSchema)` to create a new message.
 */
export const SetSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 2);
/**
 * Describes the message river.SetSettingsResponse.
 * Use `create(SetSettingsResponseSchema)` to create a new message.
 */
export const SetSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 3);
/**
 * Describes the message river.DmChannelSetting.
 * Use `create(DmChannelSettingSchema)` to create a new message.
 */
export const DmChannelSettingSchema = /*@__PURE__*/ messageDesc(file_notifications, 4);
/**
 * Describes the message river.GdmChannelSetting.
 * Use `create(GdmChannelSettingSchema)` to create a new message.
 */
export const GdmChannelSettingSchema = /*@__PURE__*/ messageDesc(file_notifications, 5);
/**
 * Describes the message river.SpaceChannelSetting.
 * Use `create(SpaceChannelSettingSchema)` to create a new message.
 */
export const SpaceChannelSettingSchema = /*@__PURE__*/ messageDesc(file_notifications, 6);
/**
 * Describes the message river.SpaceSetting.
 * Use `create(SpaceSettingSchema)` to create a new message.
 */
export const SpaceSettingSchema = /*@__PURE__*/ messageDesc(file_notifications, 7);
/**
 * Describes the message river.SetDmGdmSettingsRequest.
 * Use `create(SetDmGdmSettingsRequestSchema)` to create a new message.
 */
export const SetDmGdmSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 8);
/**
 * Describes the message river.SetDmGdmSettingsResponse.
 * Use `create(SetDmGdmSettingsResponseSchema)` to create a new message.
 */
export const SetDmGdmSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 9);
/**
 * Describes the message river.SetDmChannelSettingRequest.
 * Use `create(SetDmChannelSettingRequestSchema)` to create a new message.
 */
export const SetDmChannelSettingRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 10);
/**
 * Describes the message river.SetDmChannelSettingResponse.
 * Use `create(SetDmChannelSettingResponseSchema)` to create a new message.
 */
export const SetDmChannelSettingResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 11);
/**
 * Describes the message river.SetGdmChannelSettingRequest.
 * Use `create(SetGdmChannelSettingRequestSchema)` to create a new message.
 */
export const SetGdmChannelSettingRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 12);
/**
 * Describes the message river.SetGdmChannelSettingResponse.
 * Use `create(SetGdmChannelSettingResponseSchema)` to create a new message.
 */
export const SetGdmChannelSettingResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 13);
/**
 * Describes the message river.SetSpaceSettingsRequest.
 * Use `create(SetSpaceSettingsRequestSchema)` to create a new message.
 */
export const SetSpaceSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 14);
/**
 * Describes the message river.SetSpaceSettingsResponse.
 * Use `create(SetSpaceSettingsResponseSchema)` to create a new message.
 */
export const SetSpaceSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 15);
/**
 * Describes the message river.SetSpaceChannelSettingsRequest.
 * Use `create(SetSpaceChannelSettingsRequestSchema)` to create a new message.
 */
export const SetSpaceChannelSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 16);
/**
 * Describes the message river.SetSpaceChannelSettingsResponse.
 * Use `create(SetSpaceChannelSettingsResponseSchema)` to create a new message.
 */
export const SetSpaceChannelSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 17);
/**
 * Describes the message river.WebPushSubscriptionObjectKeys.
 * Use `create(WebPushSubscriptionObjectKeysSchema)` to create a new message.
 */
export const WebPushSubscriptionObjectKeysSchema = /*@__PURE__*/ messageDesc(file_notifications, 18);
/**
 * Describes the message river.WebPushSubscriptionObject.
 * Use `create(WebPushSubscriptionObjectSchema)` to create a new message.
 */
export const WebPushSubscriptionObjectSchema = /*@__PURE__*/ messageDesc(file_notifications, 19);
/**
 * Describes the message river.SubscribeWebPushRequest.
 * Use `create(SubscribeWebPushRequestSchema)` to create a new message.
 */
export const SubscribeWebPushRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 20);
/**
 * Describes the message river.SubscribeWebPushResponse.
 * Use `create(SubscribeWebPushResponseSchema)` to create a new message.
 */
export const SubscribeWebPushResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 21);
/**
 * Describes the message river.UnsubscribeWebPushRequest.
 * Use `create(UnsubscribeWebPushRequestSchema)` to create a new message.
 */
export const UnsubscribeWebPushRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 22);
/**
 * Describes the message river.UnsubscribeWebPushResponse.
 * Use `create(UnsubscribeWebPushResponseSchema)` to create a new message.
 */
export const UnsubscribeWebPushResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 23);
/**
 * Describes the message river.SubscribeAPNRequest.
 * Use `create(SubscribeAPNRequestSchema)` to create a new message.
 */
export const SubscribeAPNRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 24);
/**
 * Describes the message river.APNSubscription.
 * Use `create(APNSubscriptionSchema)` to create a new message.
 */
export const APNSubscriptionSchema = /*@__PURE__*/ messageDesc(file_notifications, 25);
/**
 * Describes the message river.SubscribeAPNResponse.
 * Use `create(SubscribeAPNResponseSchema)` to create a new message.
 */
export const SubscribeAPNResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 26);
/**
 * Describes the message river.UnsubscribeAPNRequest.
 * Use `create(UnsubscribeAPNRequestSchema)` to create a new message.
 */
export const UnsubscribeAPNRequestSchema = /*@__PURE__*/ messageDesc(file_notifications, 27);
/**
 * Describes the message river.UnsubscribeAPNResponse.
 * Use `create(UnsubscribeAPNResponseSchema)` to create a new message.
 */
export const UnsubscribeAPNResponseSchema = /*@__PURE__*/ messageDesc(file_notifications, 28);
/**
 * DmChannelSettingValue specifies if the user wants to receive notifications for DM streams.
 * This can be overwritten with DM channel specific configuration.
 *
 * @generated from enum river.DmChannelSettingValue
 */
export var DmChannelSettingValue;
(function (DmChannelSettingValue) {
    /**
     * DM_UNSPECIFIED not set, assumes DM_MESSAGES_YES as a default.
     *
     * @generated from enum value: DM_UNSPECIFIED = 0;
     */
    DmChannelSettingValue[DmChannelSettingValue["DM_UNSPECIFIED"] = 0] = "DM_UNSPECIFIED";
    /**
     * DM_MESSAGES_YES indicates that the user wants to receive notifications for DM channels.
     *
     * @generated from enum value: DM_MESSAGES_YES = 1;
     */
    DmChannelSettingValue[DmChannelSettingValue["DM_MESSAGES_YES"] = 1] = "DM_MESSAGES_YES";
    /**
     * DM_MESSAGES_NO indicates that the user doesn't want to receive notifications for DM channels.
     *
     * @generated from enum value: DM_MESSAGES_NO = 2;
     */
    DmChannelSettingValue[DmChannelSettingValue["DM_MESSAGES_NO"] = 2] = "DM_MESSAGES_NO";
    /**
     * DM_MESSAGES_NO_AND_MUTE indicates that the user doesn't want to receive notifications for DM channels
     * and the UI should not render any feedback that a message was received.
     *
     * @generated from enum value: DM_MESSAGES_NO_AND_MUTE = 3;
     */
    DmChannelSettingValue[DmChannelSettingValue["DM_MESSAGES_NO_AND_MUTE"] = 3] = "DM_MESSAGES_NO_AND_MUTE";
})(DmChannelSettingValue || (DmChannelSettingValue = {}));
/**
 * Describes the enum river.DmChannelSettingValue.
 */
export const DmChannelSettingValueSchema = /*@__PURE__*/ enumDesc(file_notifications, 0);
/**
 * GdmChannelSettingValue is a default setting that is applied to all GDM streams a user is in and can be
 * overwritten by GDM channel specific settings.
 *
 * @generated from enum river.GdmChannelSettingValue
 */
export var GdmChannelSettingValue;
(function (GdmChannelSettingValue) {
    /**
     * GDM_UNSPECIFIED not set, assumes GDM_MESSAGES_ALL as a default.
     *
     * @generated from enum value: GDM_UNSPECIFIED = 0;
     */
    GdmChannelSettingValue[GdmChannelSettingValue["GDM_UNSPECIFIED"] = 0] = "GDM_UNSPECIFIED";
    /**
     * GDM_MESSAGES_NO indicates that the user will not receive notifications for GDM channels.
     *
     * @generated from enum value: GDM_MESSAGES_NO = 1;
     */
    GdmChannelSettingValue[GdmChannelSettingValue["GDM_MESSAGES_NO"] = 1] = "GDM_MESSAGES_NO";
    /**
     * GDM_MESSAGES_NO_AND_MUTE indicates that the user doesn't want to receive notifications for GDM channels
     * and the UI should not render any feedback that a message was received.
     *
     * @generated from enum value: GDM_MESSAGES_NO_AND_MUTE = 2;
     */
    GdmChannelSettingValue[GdmChannelSettingValue["GDM_MESSAGES_NO_AND_MUTE"] = 2] = "GDM_MESSAGES_NO_AND_MUTE";
    /**
     * GDM_ONLY_MENTIONS_REPLIES_REACTIONS indicates that the user receives notifications for messages added to
     * GDM channels that are either a direct reply or a reaction to his own messages.
     *
     * @generated from enum value: GDM_ONLY_MENTIONS_REPLIES_REACTIONS = 3;
     */
    GdmChannelSettingValue[GdmChannelSettingValue["GDM_ONLY_MENTIONS_REPLIES_REACTIONS"] = 3] = "GDM_ONLY_MENTIONS_REPLIES_REACTIONS";
    /**
     * GDM_MESSAGES_ALL indicates that the user receives notifications for all messages in GDM channels.
     * This is the default.
     *
     * @generated from enum value: GDM_MESSAGES_ALL = 4;
     */
    GdmChannelSettingValue[GdmChannelSettingValue["GDM_MESSAGES_ALL"] = 4] = "GDM_MESSAGES_ALL";
})(GdmChannelSettingValue || (GdmChannelSettingValue = {}));
/**
 * Describes the enum river.GdmChannelSettingValue.
 */
export const GdmChannelSettingValueSchema = /*@__PURE__*/ enumDesc(file_notifications, 1);
/**
 * SpaceSettingValue is a user specified setting that is applied to all channels in a space by default and can be
 * overwritten with channel specific settings.
 *
 * @generated from enum river.SpaceChannelSettingValue
 */
export var SpaceChannelSettingValue;
(function (SpaceChannelSettingValue) {
    /**
     * SPACE_CHANNEL_SETTING_UNSPECIFIED not set, assumes SPACE_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS as default.
     *
     * @generated from enum value: SPACE_CHANNEL_SETTING_UNSPECIFIED = 0;
     */
    SpaceChannelSettingValue[SpaceChannelSettingValue["SPACE_CHANNEL_SETTING_UNSPECIFIED"] = 0] = "SPACE_CHANNEL_SETTING_UNSPECIFIED";
    /**
     * SPACE_CHANNEL_SETTING_NO_MESSAGES indicates that the user won't receive notifications of any channel in the space.
     *
     * @generated from enum value: SPACE_CHANNEL_SETTING_NO_MESSAGES = 1;
     */
    SpaceChannelSettingValue[SpaceChannelSettingValue["SPACE_CHANNEL_SETTING_NO_MESSAGES"] = 1] = "SPACE_CHANNEL_SETTING_NO_MESSAGES";
    /**
     * SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE indicates that the user won't receive notifications of any channel in
     * the space and the UI must not render any feedback that a message was received.
     *
     * @generated from enum value: SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE = 2;
     */
    SpaceChannelSettingValue[SpaceChannelSettingValue["SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE"] = 2] = "SPACE_CHANNEL_SETTING_NO_MESSAGES_AND_MUTE";
    /**
     * SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS indicates that the user will receive notifications for
     * messages that either the user is mentioned in or are a direct reply/reaction to his own message. This is the
     * default.
     *
     * @generated from enum value: SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS = 3;
     */
    SpaceChannelSettingValue[SpaceChannelSettingValue["SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS"] = 3] = "SPACE_CHANNEL_SETTING_ONLY_MENTIONS_REPLIES_REACTIONS";
    /**
     * SPACE_CHANNEL_SETTING_MESSAGES_ALL indicates that the user will receive notifications for all types of
     * messages/reactions for all channels in the space.
     *
     * @generated from enum value: SPACE_CHANNEL_SETTING_MESSAGES_ALL = 4;
     */
    SpaceChannelSettingValue[SpaceChannelSettingValue["SPACE_CHANNEL_SETTING_MESSAGES_ALL"] = 4] = "SPACE_CHANNEL_SETTING_MESSAGES_ALL";
})(SpaceChannelSettingValue || (SpaceChannelSettingValue = {}));
/**
 * Describes the enum river.SpaceChannelSettingValue.
 */
export const SpaceChannelSettingValueSchema = /*@__PURE__*/ enumDesc(file_notifications, 2);
/**
 * @generated from enum river.APNEnvironment
 */
export var APNEnvironment;
(function (APNEnvironment) {
    /**
     * APN_ENVIRONMENT_UNSPECIFIED is invalid.
     *
     * @generated from enum value: APN_ENVIRONMENT_UNSPECIFIED = 0;
     */
    APNEnvironment[APNEnvironment["APN_ENVIRONMENT_UNSPECIFIED"] = 0] = "APN_ENVIRONMENT_UNSPECIFIED";
    /**
     * APN_ENVIRONMENT_PRODUCTION uses Apple's APN service to deliver notifications.
     *
     * @generated from enum value: APN_ENVIRONMENT_PRODUCTION = 1;
     */
    APNEnvironment[APNEnvironment["APN_ENVIRONMENT_PRODUCTION"] = 1] = "APN_ENVIRONMENT_PRODUCTION";
    /**
     * APN_ENVIRONMENT_SANDBOX uses Apple's sandbox environment to send notifications.
     * Only used for development purposes.
     *
     * @generated from enum value: APN_ENVIRONMENT_SANDBOX = 2;
     */
    APNEnvironment[APNEnvironment["APN_ENVIRONMENT_SANDBOX"] = 2] = "APN_ENVIRONMENT_SANDBOX";
})(APNEnvironment || (APNEnvironment = {}));
/**
 * Describes the enum river.APNEnvironment.
 */
export const APNEnvironmentSchema = /*@__PURE__*/ enumDesc(file_notifications, 3);
/**
 * NotificationPushVersion specifies the notification format version.
 *
 * @generated from enum river.NotificationPushVersion
 */
export var NotificationPushVersion;
(function (NotificationPushVersion) {
    /**
     * @generated from enum value: NOTIFICATION_PUSH_VERSION_UNSPECIFIED = 0;
     */
    NotificationPushVersion[NotificationPushVersion["NOTIFICATION_PUSH_VERSION_UNSPECIFIED"] = 0] = "NOTIFICATION_PUSH_VERSION_UNSPECIFIED";
    /**
     * @generated from enum value: NOTIFICATION_PUSH_VERSION_1 = 1;
     */
    NotificationPushVersion[NotificationPushVersion["NOTIFICATION_PUSH_VERSION_1"] = 1] = "NOTIFICATION_PUSH_VERSION_1";
    /**
     * @generated from enum value: NOTIFICATION_PUSH_VERSION_2 = 2;
     */
    NotificationPushVersion[NotificationPushVersion["NOTIFICATION_PUSH_VERSION_2"] = 2] = "NOTIFICATION_PUSH_VERSION_2";
})(NotificationPushVersion || (NotificationPushVersion = {}));
/**
 * Describes the enum river.NotificationPushVersion.
 */
export const NotificationPushVersionSchema = /*@__PURE__*/ enumDesc(file_notifications, 4);
/**
 * NotificationService allows user to set notification related preferences for messages added to channels within a
 * space, DM and GDM channels.
 *
 * These functions are all authenticated and require a session token to be passed through the authorization metadata.
 * This session token can be obtained from the AuthenticationService. If the session token is missing or invalid an
 * Err_UNAUTHENTICATED (code=16) is returned.
 *
 * @generated from service river.NotificationService
 */
export const NotificationService = /*@__PURE__*/ serviceDesc(file_notifications, 0);
//# sourceMappingURL=notifications_pb.js.map